// extracted by mini-css-extract-plugin
module.exports = {"bar":"AgentToolbar_bar__w_prh","collapsedBar":"AgentToolbar_collapsedBar__KojBh","toggle":"AgentToolbar_toggle__7QKQa","stats":"AgentToolbar_stats__6GXur"};